import { imgPartnersSubwayLogoPng } from '@public';
import Image from 'next/image';
import SmartLink from '../SmartLink';

type FootballLinesProps = {
	count?: number;
	align?: 'top' | 'bottom';
	color?: string;
};

const _SponsorBanner = () => {
	return (
		<div className="absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-2">
			<p className="text-[12px] leading-[1.5] font-bold whitespace-nowrap uppercase not-italic [leading-trim:both] [text-edge:cap]">
				presented by
			</p>
			<SmartLink href="https://www.subway.com" target="_blank">
				<Image src={imgPartnersSubwayLogoPng} alt="Subway Logo" className="h-[14px] w-[70px]" width={70} height={14} />
			</SmartLink>
		</div>
	);
};

const FootballLines = ({ count = 89, align = 'top', color = 'bg-black' }: FootballLinesProps) => {
	const getHeight = (i: number) => {
		const n = i + 1;
		if (n % 5 === 0) return 'h-[32px] md:h-[44px]';
		return 'h-[16px] md:h-[23px]';
	};

	return (
		<div className="relative top-0 flex w-full justify-evenly" aria-hidden="true">
			{[...Array(count)].map((_, i) => (
				<span key={i} className={`w-px ${getHeight(i)} ${color} ${align === 'top' ? 'self-start' : 'self-end'}`} />
			))}
			<_SponsorBanner />
		</div>
	);
};

export default FootballLines;
